import { render, staticRenderFns } from "./ConsumenDetail.vue?vue&type=template&id=7a0969ef"
import script from "./ConsumenDetail.vue?vue&type=script&lang=js"
export * from "./ConsumenDetail.vue?vue&type=script&lang=js"
import style0 from "./ConsumenDetail.vue?vue&type=style&index=0&id=7a0969ef&prod&lang=css"
import style1 from "./ConsumenDetail.vue?vue&type=style&index=1&id=7a0969ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports